<template>
  <div>
    <compound-interest-graph :labels="graphLabels" :data="graphData" />
    <v-card class="card elevation-0 pa-4">
      <v-radio-group v-model="model" row>
        <v-radio label="Declining" value="declining"></v-radio>
        <v-radio label="Flat" value="flat"></v-radio>
        <v-radio label="Growing" value="growing"></v-radio>
      </v-radio-group>
      <v-row>
        <v-col>
          <currency-field
            :dense="false"
            label="Starting Savings"
            klass="starting-value"
            v-model="startingValue"
          />
        </v-col>
        <v-col>
          <v-text-field
            hide-details
            reverse
            label="Assumed Investment Return"
            class="return-percent"
            type="number"
            v-model="returnPercent"
            prefix="%"
          />
        </v-col>
        <v-col>
          <currency-field
            :dense="false"
            label="Annual Additional Savings"
            klass="additional-savings"
            v-model="additions"
          />
        </v-col>
        <v-col>
          <currency-field
            :dense="false"
            label="Annual Withdrawals to supplement spending"
            klass="withdrawals"
            v-model="withdrawals"
          />
        </v-col>
        <v-col>
          <v-text-field
            hide-details
            reverse
            label="Starting Age"
            type="number"
            class="age"
            v-model="startingAge"
            oninput="if(this.value.length > 2) this.value = this.value.substring(0, 2)"
          />
        </v-col>
        <v-col>
          <v-text-field
            hide-details
            reverse
            label="Number of years"
            type="number"
            class="years"
            v-model="years"
            oninput="if(this.value.length > 2) this.value = this.value.substring(0, 2)"
          />
        </v-col>
      </v-row>
    </v-card>
    <v-data-table
      dense
      disable-pagination
      hide-default-footer
      :headers="headers"
      :items="items"
    >
      <template v-slot:item.age="{ item }">{{
        isNaN(item.age) ? "" : item.age
      }}</template>
      <template v-slot:item.startingValue="{ item }">{{
        formatCurrency(item.startingValue)
      }}</template>
      <template v-slot:item.investmentReturn="{ item }">{{
        formatCurrency(item.investmentReturn)
      }}</template>
      <template v-slot:item.additions="{ item }">{{
        formatCurrency(item.additions)
      }}</template>
      <template v-slot:item.withdrawals="{ item }">{{
        formatCurrency(item.withdrawals)
      }}</template>
      <template v-slot:item.endingValue="{ item }">{{
        formatCurrency(item.endingValue)
      }}</template>
    </v-data-table>
  </div>
</template>

<script>
import CurrencyField from "@/components/CurrencyField"
import CompoundInterestGraph from "@/components/tools/interest/CompoundInterestGraph"

import titleMixin from "@/mixins/titleMixin"

export default {
  mixins: [titleMixin],
  components: { CurrencyField, CompoundInterestGraph },
  computed: {
    model: {
      get() {
        return this.modelValue
      },
      set(newValue) {
        console.log(newValue)
        this.modelValue = newValue

        switch (newValue) {
          case "declining":
            ;(this.startingValueData = 10000), (this.returnRate = 0.07)
            this.additions = 0
            this.withdrawals = 1000
            break
          case "flat":
            ;(this.startingValueData = 10000), (this.returnRate = 0.07)
            this.additions = 0
            this.withdrawals = 700
            break
          default:
            ;(this.startingValueData = 10000), (this.returnRate = 0.07)
            this.additions = 500
            this.withdrawals = 200
        }
      }
    },
    startingValue: {
      get() {
        return this.startingValueData
      },
      set(newValue) {
        console.log(newValue)
        this.startingValueData = parseFloat(newValue)
      }
    },
    returnPercent: {
      get() {
        return parseInt(this.returnRate * 100)
      },
      set(newValue) {
        let val = newValue ? newValue : 0
        this.returnRate = parseInt(val) / 100
      }
    },
    items() {
      let items = []
      for (let i = 0; i < parseInt(this.years); i++) {
        let year = parseInt(this.startingYear) + i
        let startingAge = parseInt(this.startingAge) + i
        let startingValue =
          i == 0 ? parseFloat(this.startingValue) : items[i - 1].endingValue
        let investmentReturn = startingValue * parseFloat(this.returnRate)
        let additions = parseFloat(this.additions)
        let withdrawals = parseFloat(this.withdrawals)
        let endingValue =
          startingValue - withdrawals + additions + investmentReturn

        items.push({
          year: year,
          age: startingAge,
          startingValue: startingValue,
          investmentReturn: investmentReturn,
          additions: additions,
          withdrawals: withdrawals,
          endingValue: endingValue
        })
      }
      return items
    },
    graphData() {
      return this.items.map(el => el.endingValue)
    },
    graphLabels() {
      return this.items.map(el => el.year)
    }
  },
  data() {
    return {
      title: "Understanding The Impact of Current Choices on the Future",
      headers: [
        { text: "Year", value: "year", align: "end" },
        { text: "Age", value: "age", align: "end" },
        {
          text: "Account Starting Value",
          value: "startingValue",
          align: "end"
        },
        { text: "Investment Return", value: "investmentReturn", align: "end" },
        { text: "Additions", value: "additions", align: "end" },
        { text: "Withdrawals", value: "withdrawals", align: "end" },
        { text: "Account Ending Value", value: "endingValue", align: "end" }
      ],
      modelValue: "declining",
      startingYear: 2022,
      startingAge: 18,
      years: 30,
      startingValueData: 10000,
      returnRate: 0.07,
      additions: 0,
      withdrawals: 1000
    }
  },

  methods: {
    formatCurrency(value) {
      let returnString = new Intl.NumberFormat(`en-US`, {
        currency: `USD`,
        style: "currency"
      })
        .format(Math.round(value))
        .replace(/\.00/, "")

      return value >= 0 ? returnString : `(${returnString})`
    }
  }
}
</script>
